export default "__VITE_ASSET__Eb5nUc0v__"